import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Box, Paper, Typography, Button, CircularProgress, styled } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  maxWidth: 400,
  width: "100%",
  borderRadius: 12,
}));

const IconWrapper = styled(Box)(({ theme }) => ({
  width: 80,
  height: 80,
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: theme.spacing(2),
  "& svg": {
    fontSize: 40,
    color: "white",
  },
}));

const VerificationPage = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [isSuccess, setIsSuccess] = useState(false);

  const API_BASE_URL = process.env.REACT_APP_BASE_API;

  useEffect(() => {
    const verifyUser = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}verify/${token}`, {
          headers: {
            "ngrok-skip-browser-warning": "true",
          },
        });
        const data = await response.json();
        setIsSuccess(response.ok);
      } catch (error) {
        setIsSuccess(false);
      } finally {
        setLoading(false);
      }
    };

    verifyUser();
  }, [token]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "primary.main",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
      }}
    >
      <StyledPaper elevation={3}>
        {loading ? (
          <CircularProgress size={60} sx={{ my: 4 }} />
        ) : (
          <>
            <IconWrapper
              sx={{
                bgcolor: isSuccess ? "primary.main" : "error.main",
              }}
            >
              {isSuccess ? <CheckCircleOutlineIcon /> : <ErrorOutlineIcon />}
            </IconWrapper>

            <Typography variant="h4" component="h2" sx={{ mb: 1 }}>
              {isSuccess ? "Verified!" : "Verification Failed"}
            </Typography>

            <Typography variant="body1" color="text.secondary" sx={{ mb: 4, textAlign: "center" }}>
              {isSuccess
                ? "You have successfully verified account."
                : "Oops! Something went wrong with the verification."}
            </Typography>

            <Button
              variant="contained"
              size="large"
              onClick={() => navigate("/admin/login")}
              sx={{
                px: 4,
                borderRadius: 2,
                textTransform: "none",
                fontSize: "1.1rem",
              }}
            >
              Login
            </Button>
          </>
        )}
      </StyledPaper>
    </Box>
  );
};

export default VerificationPage;
